// removed by extract-text-webpack-plugin
module.exports = {"container":"type-cell-formatter__container___11LVr","tooltip":"type-cell-formatter__tooltip___2jTtt"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/grid/cell-formatters/type-cell-formatter.scss
// module id = 1338
// module chunks = 0